import { Paper, Title, Text, Stack, Collapse, Group, UnstyledButton } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";

interface FormSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultExpanded?: boolean;
}

export function FormSection({
  title,
  description,
  children,
  collapsible = false,
  defaultExpanded = true,
}: FormSectionProps) {
  const [expanded, { toggle }] = useDisclosure(defaultExpanded);

  const header = (
    <Group gap="xs">
      {collapsible && (
        expanded ? <IconChevronDown size={16} /> : <IconChevronRight size={16} />
      )}
      <div>
        <Title order={5}>{title}</Title>
        {description && (
          <Text size="xs" c="dimmed">
            {description}
          </Text>
        )}
      </div>
    </Group>
  );

  return (
    <Paper p="md" withBorder>
      {collapsible ? (
        <>
          <UnstyledButton onClick={toggle} w="100%">
            {header}
          </UnstyledButton>
          <Collapse expanded={expanded}>
            <Stack gap="md" mt="md">
              {children}
            </Stack>
          </Collapse>
        </>
      ) : (
        <>
          {header}
          <Stack gap="md" mt="md">
            {children}
          </Stack>
        </>
      )}
    </Paper>
  );
}
